<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Statistics</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in statisticsItems"
          :key="item.icon"
          md="4"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { API, Auth } from 'aws-amplify'
import * as queries from '../../graphql/queries'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  data() {
    return {
      statisticsItems: [
        {
          icon: 'UsersIcon',
          title: '?',
          subtitle: 'Users',
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'BarChartIcon',
          title: '?',
          subtitle: 'Dashboards',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'WifiIcon',
          title: '8.549k',
          subtitle: 'Networks',
          customClass: 'mb-2 mb-xl-0',
        },
      ],
      loading: false,
      users: [],
    }
  },
  created() {
    this.getWorkspace()
    this.getUsers()
  },
  methods: {
    async getWorkspace() {
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      const workspace = await API.graphql({
        query: queries.getWorkspace,
        variables: { id: workspaceId },
      })
      // this.statisticsItems[0].title = workspace.data.getWorkspace.users.items.length
      this.statisticsItems[1].title = workspace.data.getWorkspace.dashboards.items.length
      this.statisticsItems[2].title = workspace.data.getWorkspace.networks.items.length
    },
    async getUsers() {
      const workspace = await JSON.parse(localStorage.getItem('workspace'))
      this.loading = true
      try {
        const apiName = 'AdminQueries'
        const path = '/listUsersInGroup'
        const myInit = {
          queryStringParameters: {
            groupname: workspace.id,
          },
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
        }
        const response = await API.get(apiName, path, myInit)
        // There is duplicate users only keep the ones with the highest role. groupname has the role in it so we can sort by that
        const uniqueUsers = response.reduce((acc, user) => {
          if (!acc.find(u => u.Username === user.Username)) {
            acc.push({ ...user, role: user.groupname.split('.')[1] })
          }
          return acc
        }, [])
        this.loading = false
        this.users = uniqueUsers
        this.statisticsItems[0].title = this.users.length
      } catch (error) {
        // console.log(error)
      }
    },
  },
}
</script>
